export interface DesiredPlace {
  "@id": string;
  value: string;
}

export const desiredPlacesRemote = ["Télétravail complet", "Télétravail partiel", "Présentiel"];
